import { render, staticRenderFns } from "./PartnerCreateInquiryReg.vue?vue&type=template&id=1af9d536&scoped=true"
import script from "./PartnerCreateInquiryReg.vue?vue&type=script&lang=js"
export * from "./PartnerCreateInquiryReg.vue?vue&type=script&lang=js"
import style0 from "./PartnerCreateInquiryReg.vue?vue&type=style&index=0&id=1af9d536&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af9d536",
  null
  
)

export default component.exports